<template>
  <div class="auth-screen">
    <h2 class="mb-4">
      Additional Authentication Required
    </h2>
    <p>
      An {{ details.AttributeName }} has been sent to {{ details.Destination }}
      Please enter the authorization code from that message and a new
      password.
    </p>
    <b-container class="auth-block has-border">
      <b-row>
        <b-col>
          <label for="input-token">Token</label>
          <b-form-input
            id="input-token"
            v-model.trim="token"
            type="text"
            @keyup.13="onSubmitClick"
          />
        </b-col>
        <b-col v-if="passWordEnabled">
          <label for="new-password">New Password</label>
          <b-form-input
            id="new-password"
            v-model.trim="password"
            type="password"
            @keyup.13="onSubmitClick"
          />
        </b-col>
      </b-row>
      <b-row>
        <b-col class="d-flex justify-content-end flex-no-wrap mt-3">
          <div
            v-if="error"
            class="mr-4 alert alert-danger fade show"
            role="alert"
          >
            {{ error }}
          </div>
          <b-button
            class="mr-2 ml-2 btn btn-secondary"
            variant="secondary"
            title="Cancel"
            @click="onCancel"
          >
            Cancel
          </b-button>
          <b-button
            variant="primary"
            title="Confirm"
            @click="onSubmitClick"
          >
            Confirm
          </b-button>
        </b-col>
      </b-row>
    </b-container>
    <div class="mt-4 d-flex">
      If you have not received the message after five minutes, or if you
      need immediate assistance, please contact the CDS Global help desk at
      (515) 246-1001 or via email at cdshelpdesk@cds-global.com
    </div>
  </div>
</template>

<script>
export default {
  name: 'ConfirmAuth',
  props: {
    error: {
      type: String,
      default: ''
    },
    details: {
      type: Object,
      default: function () {
        return {
          AttributeName: '',
          DeliveryMedium: '',
          Destination: ''
        }
      }
    },
    confirmState: {
      type: String,
      default: ''
    }
  },
  data: function () {
    return {
      token: '',
      password: ''
    }
  },
  computed: {
    passWordEnabled: function () {
      return this.confirmState !== 'signInConfirm'
    }
  },
  methods: {
    onSubmitClick: function () {
      this.$emit('submit-confirm', this.token, this.password)
    },
    onCancel() {
      this.$emit('cancel-confirm')
    }
  }
}
</script>

<style lang="scss" scoped>
  @import '~@/assets/styles/main.scss';
  @import '~@/assets/styles/auth.scss';
</style>

